module.exports = __webpack_public_path__ + "media/images/assignment/edit-8859d9662ba3068cbde77a86ce501767.svg";